import Swiper from 'swiper';
import {Autoplay, Mousewheel, Pagination, Navigation, Keyboard, FreeMode, Thumbs} from 'swiper/modules';
import jsKit from './jsKit';

export const swipers = (() => {

    return {
        mainSwiperInit: () => {
            if (!document.querySelector('#main-swiper')) {
                return;
            }

            const swiperLG = document.querySelector('#main-swiper');

            const swiperLGInstance = new Swiper(swiperLG, {
                init: false,
                modules: [Pagination, Autoplay, Navigation, FreeMode],
                direction: 'horizontal',
                loop: true,
                speed: 1200,
                watchOverflow: true,
                slidesPerView: 1,
                spaceBetween: 0,
                freeMode: false,
                autoplay: {
                    enabled: true,
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                },
                pagination: {
                    el: swiperLG.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                navigation: {
                    nextEl: swiperLG.querySelector('[data-swiper-button-next]'),
                    prevEl: swiperLG.querySelector('[data-swiper-button-prev]'),
                },
            });

            ['init', 'slideChange'].forEach((event) => swiperLGInstance.on(event, () => {
                if (jsKit.rwdMedia.xs() || jsKit.rwdMedia.sm()) {return;}
                swiperLG.querySelectorAll('.swiper-pagination-bullet').forEach((el) => {
                    el.classList.remove('count-down');
                    void el.offsetWidth;
                });
                const activeBullet = swiperLG.querySelector('.swiper-pagination-bullet-active');
                if (activeBullet) activeBullet.classList.add('count-down');
            }));

            swiperLGInstance.init();
        },

        swiperProductCardInit: () => {
            if (!document.querySelector('#swiper-product-photos')) {
                return;
            };

            const swiperElThumbs = document.querySelector('#swiper-thumb-pagination');

            const swiperThumbs = new Swiper(swiperElThumbs, {
                modules: [Navigation, Mousewheel],
                spaceBetween: 16,
                breakpoints: {
                    240: {
                        slidesPerView: 3.5,
                        spaceBetween: 8,
                    },
                    320: {
                        slidesPerView: 3.5,
                        spaceBetween: 8,
                    },
                    380: {
                        slidesPerView: 4,
                        spaceBetween: 8,
                    },
                    576: {
                        slidesPerView: 4,
                        spaceBetween: 8,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 8,
                    },
                    992: {
                        slidesPerView: 4.5,
                    },
                    1200: {
                        slidesPerView: 5.5,
                    },
                },
                freeMode: true,
                mousewheel: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: swiperElThumbs.querySelector('[data-swiper-button-next]'),
                    prevEl: swiperElThumbs.querySelector('[data-swiper-button-prev]'),
                },
            });

            const swiperEl = document.querySelector('#swiper-product-photos');

            const swiperProductsPhotos = new Swiper(swiperEl, {
                modules: [Thumbs, Navigation, Keyboard],
                direction: 'horizontal',
                slidesPerView: 1,
                spaceBetween: 10,
                thumbs: {
                    slideThumbActiveClass: 'border-primary',
                    autoScrollOffset: 1,
                    swiper: swiperThumbs,
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: false,
                },
                navigation: {
                    nextEl: swiperEl.querySelector('[data-swiper-button-next]'),
                    prevEl: swiperEl.querySelector('[data-swiper-button-prev]'),
                },
            });

            return swiperProductsPhotos;
        },
    }

})();